import {
  Header1,
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithTextarea,
} from "../../BlockComponent";
import { LastCard } from "../common";

export const Content_10_3_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),
  Instruction("typography_mobile_notice"),

  InstructionWithTextarea("typography_3", {
    placeholder: "구체적인 예시와 함께 작성해주세요",
  }),
  InstructionWithTextarea("typography_4", {
    placeholder: "구체적인 예시와 함께 작성해주세요",
  }),
  InstructionWithTextarea("typography_5", {
    placeholder: "구체적인 예시와 함께 작성해주세요",
  }),
  InstructionWithTextarea("typography_6", {
    placeholder: "구체적인 예시와 함께 작성해주세요",
  }),

  Header1("typography_7"),
  Instruction("typography_8"),
  Instruction("typography_9"),

  InstructionWithButtonGroup(
    "typography_10",
    [
      { text: "완벽하게 행복해질 것이다." },
      { text: "중요한 것을 잃어버린 느낌이 들 것이다." },
      { text: "감정을 느끼지 못하는 기계처럼 될 것이다." },
    ],
    { id: "magic_button_choice", vertical: true }
  ),

  Header1("typography_11"),
  Instruction("typography_12"),
  Instruction("typography_13"),
  Instruction("typography_14"),

  Header1("typography_15"),
  Instruction("typography_16"),
  Instruction("typography_17"),
  Instruction("typography_18"),

  InstructionWithButtonGroup(
    "typography_19",
    [
      { text: "0-2 (거의 느끼고 싶지 않다)" },
      { text: "3-5 (일상에 방해받지 않을 정도로만 느끼고 싶다)" },
      { text: "6-8 (조금 힘들지만 충분히 곱씹고 싶다)" },
    ],
    { id: "emotion_dial_target", vertical: true }
  ),

  Header1("typography_20"),
  Instruction("typography_21"),
  Instruction("typography_22"),

  ...LastCard,
];
